import React, { useState } from 'react';
import { Button } from './ui/button';
import { Share2, Check as CheckIcon, ExternalLink } from 'lucide-react';
import { toast } from 'sonner';

const fallbackCopy = (text) => {
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try { ok = document.execCommand('copy'); } catch { ok = false; }
  document.body.removeChild(ta);
  return ok;
};

const ShareYourProfileCard = ({ user }) => {
  const [copied, setCopied] = useState(false);
  if (!user?.id) return null;

  const profileUrl = `${window.location.origin}/trainers/${user.id}`;
  const tweetText = encodeURIComponent(
    `Book me on DojoDash, at-home personal training, self-defense and Jiu-Jitsu. ${profileUrl}`
  );

  const handleCopy = async () => {
    let ok = false;
    if (navigator.clipboard && window.isSecureContext) {
      try { await navigator.clipboard.writeText(profileUrl); ok = true; }
      catch { ok = fallbackCopy(profileUrl); }
    } else {
      ok = fallbackCopy(profileUrl);
    }
    if (ok) {
      setCopied(true);
      toast.success('Link copied');
      setTimeout(() => setCopied(false), 1500);
    } else {
      toast.error('Could not copy');
    }
  };

  return (
    <div
      className="mb-8 bg-[#18181B] border border-[#C0A062]/20 rounded-lg p-5"
      data-testid="share-your-profile-card"
    >
      <div className="flex items-start gap-4 flex-wrap">
        <div className="shrink-0 w-10 h-10 rounded-lg bg-[#C0A062]/10 border border-[#C0A062]/30 flex items-center justify-center">
          <Share2 className="w-5 h-5 text-[#C0A062]" />
        </div>
        <div className="flex-1 min-w-[200px]">
          <p className="text-sm font-semibold text-white mb-3">Share your profile</p>
          <div className="flex items-center gap-2 bg-[#09090B] border border-zinc-800 rounded-md px-3 py-2 mb-3">
            <code className="text-xs text-zinc-300 truncate flex-1" data-testid="share-profile-url">
              {profileUrl}
            </code>
          </div>
          <div className="flex flex-wrap gap-2">
            <Button
              size="sm"
              onClick={handleCopy}
              className="bg-[#C0A062] text-black hover:bg-[#a98a52] font-semibold"
              data-testid="share-card-copy-btn"
            >
              {copied ? <><CheckIcon className="w-4 h-4 mr-1.5" />Copied</> : <><Share2 className="w-4 h-4 mr-1.5" />Copy link</>}
            </Button>
            <a
              href={`https://twitter.com/intent/tweet?text=${tweetText}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-xs text-zinc-300 hover:text-white px-3 py-1.5 rounded-md border border-zinc-700 hover:bg-zinc-800"
              data-testid="share-card-tweet-link"
            >
              Tweet this <ExternalLink className="w-3 h-3 ml-1.5" />
            </a>
            <a
              href={profileUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center text-xs text-zinc-300 hover:text-white px-3 py-1.5 rounded-md border border-zinc-700 hover:bg-zinc-800"
              data-testid="share-card-preview-link"
            >
              Preview <ExternalLink className="w-3 h-3 ml-1.5" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareYourProfileCard;
